export default {
  head: {
    title: 'USSD sessions billing',
    action: {
      create: {
        tooltip: 'Create new USSD report'
      },
      search: {
        tooltip: 'Search single session by Session Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search USSD billing session'
    },
    details: {
      title: 'USSD session details'
    }
  }
};
